<template>
	<div class="table-container" style="width: 100%;padding: 20px;">
		<div style="display: flex;padding-bottom: 20px;align-items: center;justify-content: space-between;">
			<div style="display: flex;align-items: center;">
				<v-text-field v-model="searchUsername" label="账号" style="max-width: 180px;margin-right:20px;" hide-details
					single-line class="mx-3 mb-3" />
				<v-text-field v-model="searchCustomername" label="户主姓名" style="max-width: 180px;margin-right:20px;" hide-details
					single-line class="mx-3 mb-3" />
				<v-menu v-model="start_menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
					offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field v-model="searchStartDate" label="开始时间" prepend-icon="mdi-calendar" readonly v-bind="attrs"
							v-on="on" hide-details single-line style="max-width: 180px;margin-right:20px;" class="mx-3 mb-3"></v-text-field>
					</template>
					<v-date-picker v-model="searchStartDate" @input="start_menu = false"></v-date-picker>
				</v-menu>
				<v-menu v-model="end_menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
					offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field v-model="searchEndDate" label="结束时间" prepend-icon="mdi-calendar" readonly v-bind="attrs"
							v-on="on" hide-details single-line style="max-width: 180px;margin-right:20px;" class="mx-3 mb-3"></v-text-field>
					</template>
					<v-date-picker v-model="searchEndDate" @input="end_menu = false"></v-date-picker>
				</v-menu>
			</div>
			<div style="display: flex;">
				<v-btn @click="resetQuery" color="primary" class="mx-3">
					重置
					<v-icon right>mdi-lock-reset</v-icon>
				</v-btn>
				<v-btn @click="getList" color="primary" class="mx-3">
					查询
					<v-icon right>mdi-magnify</v-icon>
				</v-btn>
				<!-- <v-btn color="red" dark @click="removeSelected">
					批量删除 <v-icon right>mdi-delete</v-icon>
				</v-btn> -->
			</div>
		</div>
		<v-data-table v-model="selected" :items="items" :headers="headers" hide-default-footer show-select
			item-key="id">
			<template v-slot:item="{ item, isSelected, select }">
				<tr>
					<td><v-checkbox :input-value="isSelected" @change="select($event)" hide-details
							style="margin:0;padding:0;"></v-checkbox></td>
					<td>{{ item.username }}</td>
					<td>{{ item.interface }}</td>
					<td>{{ item.event }}</td>
					<td>{{ item.customername }}</td>
					<td>{{ item.details }}</td>
					<td>{{ item.create_at }}</td>
				</tr>
			</template>
		</v-data-table>
		<div class="pagination" style="margin-top: 20px;">
			<v-pagination v-model="page" @input="paginationChangeHandler" :circle="true" :length="total_pages"
				rounded="circle"></v-pagination>
		</div>
		<v-snackbar v-model="snackbar" timeout="2000"> {{ text }}</v-snackbar>
	</div>
</template>

<script>
import { getSystemLogs, delSystemLogs } from "@/api/systemLog";

export default {
	name: "systemLog",
	components: {},

	data: () => ({
		searchUsername: '',
		searchCustomername: '',
		searchStartDate: '',
		searchEndDate: '',
		start_menu: false,
		end_menu: false,
		total_pages: 0,
		page: 1,
		limit: 10,
		snackbar: false,
		text: '',
		selected: [],
		headers: [
			{ text: '账号', value: 'username', sortable: false },
			{ text: '接口', value: 'interface', sortable: false },
			{ text: '事件', value: 'event', sortable: false },
			{ text: '户主姓名', value: 'customername', sortable: false },
			{ text: '详情', value: 'details', sortable: false },
			{ text: '操作时间', value: 'create_at', sortable: false }
		],
		items: []
	}),

	created() {
		this.getList();
	},
	methods: {
		async getList() {
			let query = {
				page: this.page,
				limit: this.limit,
				username: this.searchUsername,
				customername: this.searchCustomername,
				start_time: this.searchStartDate,
				end_time: this.searchEndDate
			}
			if (this.searchUsername.length == 0) delete query.username
			if (this.searchCustomername.length == 0) delete query.customername
			if (this.searchStartDate.length == 0) delete query.start_time
			if (this.searchEndDate.length == 0) delete query.end_time
			const res = await getSystemLogs(query);
			this.items = res.data.items || [];
			this.total_pages = res.data._meta.total_pages
		},
		removeSelected() {
			if (this.selected.length == 0) {
				this.snackbar = true;
				this.text = '请先选择要删除的日志';
				return
			}
			this.$confirm("确认删除所选日志?").then(res => {
				if (res) {
					let ids = this.selected.map(item => item.id);
					delSystemLogs(ids).then(response => {
						if (response.data.error) {
							this.text = "删除失败！";
							this.snackbar = true;
						} else {
							this.text = "删除成功！";
							this.snackbar = true;
							this.selected = [];
							this.getList();
						}
					});
				}
			});
		},
		paginationChangeHandler(pageNumber) {
			this.page = pageNumber;
			this.getList();
		},
		resetQuery() {
			this.searchUsername = '';
			this.searchCustomername = '';
			this.searchStartDate = '';
			this.searchEndDate = '';
			this.page = 1;
			this.getList();
		}
	}
};
</script>

<style lang="scss" scoped>
table,
thead,
tr {
	color: #fff;
	font-weight: 400;
}

tr:hover {
	background-color: #0282b4 !important;
	color: rgb(224, 221, 221);
}
</style>
